//#region Styles
import { Content } from "./styles";
import { Container } from "../../styles";
//#endregion
//#region Components
import CampusOptionList from "./components/CampusOptionList/CampusOptionList";
//#endregion

const CampusListView = ({
    children,
    campusList,
    onCampus
}) => {
    return (
        <Container>
            {children}
            <Content>
                <CampusOptionList
                    campusList={campusList}
                    onCampus={onCampus}/>
            </Content>
        </Container>
    );
}

export default CampusListView;